import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
  Adicionar isso após o body no index.html para funcionar no iphone:


  <script>
    if ("ontouchstart" in document.documentElement) {
      document.body.style.cursor = "pointer";
    }
  </script>
 */
export default class ClickOutside extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.props.isOpen) {
        this.props.onClick();
      }
    }
  }

  render() {
    return <div ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}

ClickOutside.propTypes = {
  children: PropTypes.element.isRequired,
};
